import { ActivityStreamDto } from "../../../dtos";
import { BaseMessageType } from "./BaseMessageType";

export class EmailMessage extends BaseMessageType {
    _noun: string;
    _action: string;

    constructor(streamEntry: ActivityStreamDto, noun: string, action: string) {
        super(streamEntry);
        this._noun = noun;
        this._action = action;
    }

    getMessage(): JSX.Element[] {
        const { respondent, company, scheduleId, formType, period } = this._streamEntry;
        return this.generateMessageFromPayload({
            noun: this._noun,
            pastTenseAction: this._action,
            targetJoiningText: this._action === 'opened' ? 'by' : 'to',
            targetProperNoun: `${respondent?.firstName} ${respondent?.lastName}`,
            targetProperNounRoute: `/companies/${company?.id}/respondents/${respondent?.id}`,
            companyJoiningText: this._action === 'opened' ? 'for' : 'at',
            companyName: company?.shortName || company?.name,
            companyRoute: `/companies/${company?.id}`,
            formTypeName: formType?.name,
            formTypeRoute: `/form-types?id=${formType?.id}`,
            periodText: period,
            periodTextRoute: `/companies/${company?.id}/schedules/${scheduleId}`
        });
    }
}